import React from 'react';
import './ContentDetailsModal.css';
import { formatStorePrice, getPackImage, getPackName } from './packSelectorUtils';

const ContentDetailsModal = ({
  visible = false,
  content = null,
  loading = false,
  onClose,
  onPurchase,
}) => {
  if (!visible || !content) {
    return null;
  }

  const {
    pack,
    eyebrow,
    title,
    description,
    tags = [],
    stats = [],
    callout,
    priceLabel,
    ctaLabel,
    isLocked,
    canPurchase,
    isPurchasing,
  } = content;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && !loading) {
      onClose?.();
    }
  };

  const fallbackTitle = title || getPackName(pack);
  return (
    <div
      className="cq-content-modal-overlay"
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-label={`${fallbackTitle} preview`}
    >
      <div className="cq-content-modal">
        <button
          type="button"
          className="cq-content-modal__close"
          onClick={() => onClose?.()}
          disabled={loading}
          aria-label="Close preview"
        >
          ×
        </button>

        <div className="cq-content-modal__hero">
          <div className="cq-content-modal__art" aria-hidden="true">
            {getPackImage(pack) ? (
              <img className="cq-content-modal__art-image" src={getPackImage(pack)} alt="" />
            ) : (
              <span className="cq-content-modal__art-chip cq-chip-badge cq-chip-badge--image-only" />
            )}
          </div>

          <div className="cq-content-modal__hero-copy">
            <div className="cq-content-modal__eyebrow">{eyebrow || 'Quest Pack'}</div>
            <h2 className="cq-content-modal__title">{fallbackTitle}</h2>
            {tags.length ? (
              <div className="cq-tag-row cq-tag-row--modal">
                {tags.map((tag) => (
                  <span key={`${fallbackTitle}-${tag}`} className="cq-tag">
                    {tag}
                  </span>
                ))}
              </div>
            ) : null}
          </div>
        </div>

        <p className="cq-content-modal__description">
          {description || 'A fresh addition to the Cringe Quest rotation.'}
        </p>

        {stats.length ? (
          <div className="cq-content-modal__stats">
            {stats.map((stat) => (
              <div key={stat.label} className="cq-content-modal__stat">
                <span className="cq-content-modal__stat-label">{stat.label}</span>
                <span className="cq-content-modal__stat-value">{stat.value}</span>
              </div>
            ))}
          </div>
        ) : null}

        {callout ? (
          <div className="cq-content-modal__callout">
            <span className="cq-content-modal__callout-badge">{callout.label}</span>
            <span className="cq-content-modal__callout-copy">{callout.copy}</span>
          </div>
        ) : null}

        <div className="cq-content-modal__footer">
          {isLocked ? (
            <>
              <div className="cq-content-modal__price">{priceLabel || formatStorePrice(pack?.price_usd) || 'Premium unlock'}</div>
              <button
                type="button"
                className="cq-content-modal__cta"
                onClick={() => onPurchase?.(pack)}
                disabled={loading || !canPurchase}
              >
                {isPurchasing ? 'Redirecting...' : ctaLabel || 'Unlock Pack'}
              </button>
            </>
          ) : (
            <div className="cq-content-modal__owned">
              Already in your rotation.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentDetailsModal;
